import { normalizePdrProfile, type PdrSchemaProfile } from "./pdrFields";

const PREFIX = "orion1.desk.";

export type DeskPreferences = {
  pdr_schema_profile: PdrSchemaProfile;
  phase3_enable_pdr_reasoning: boolean;
  eval_sandbox_pdrs: Record<string, string>;
};

const DEFAULTS: DeskPreferences = {
  pdr_schema_profile: "slim",
  phase3_enable_pdr_reasoning: false,
  eval_sandbox_pdrs: { slim: "", complete: "" },
};

function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

function writeJson(key: string, value: unknown): void {
  localStorage.setItem(PREFIX + key, JSON.stringify(value));
}

export function loadDeskPreferences(): DeskPreferences {
  const pdr = normalizePdrProfile(
    localStorage.getItem(PREFIX + "pdr_schema_profile") || DEFAULTS.pdr_schema_profile,
  );
  const reasoning =
    localStorage.getItem(PREFIX + "phase3_enable_pdr_reasoning") === "true";
  const evalPdrs = readJson<Record<string, string>>(
    "eval_sandbox_pdrs",
    { ...DEFAULTS.eval_sandbox_pdrs },
  );
  return {
    pdr_schema_profile: pdr,
    phase3_enable_pdr_reasoning: reasoning,
    eval_sandbox_pdrs: evalPdrs,
  };
}

export function savePdrSchemaProfile(profile: PdrSchemaProfile): void {
  localStorage.setItem(PREFIX + "pdr_schema_profile", profile);
}

export function savePhase3EnablePdrReasoning(on: boolean): void {
  localStorage.setItem(PREFIX + "phase3_enable_pdr_reasoning", on ? "true" : "false");
}

export function saveEvalSandboxPdr(profile: string, text: string): void {
  const prefs = loadDeskPreferences();
  const next = { ...prefs.eval_sandbox_pdrs, [profile]: text };
  writeJson("eval_sandbox_pdrs", next);
}

export function evalSandboxPdr(profile: string): string {
  return loadDeskPreferences().eval_sandbox_pdrs[profile] || "";
}
